import { render, staticRenderFns } from "./table_form.vue?vue&type=template&id=2a4b853d&scoped=true&"
import script from "./table_form.vue?vue&type=script&lang=js&"
export * from "./table_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b853d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a4b853d')) {
      api.createRecord('2a4b853d', component.options)
    } else {
      api.reload('2a4b853d', component.options)
    }
    module.hot.accept("./table_form.vue?vue&type=template&id=2a4b853d&scoped=true&", function () {
      api.rerender('2a4b853d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/promotion/pro_policy/form/promotion_area/table_form.vue"
export default component.exports